import React, {
  useState,
  useCallback,
  Fragment,
  useRef,
  useEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Button } from '@material-ui/core';
import { AttachFile } from '@material-ui/icons';
import { isArray } from 'lodash';

import { t, canURL } from '~/helpers';
import api from '~/services/api';
import { recordFiltering } from '~/store/modules/notafiscalrecebida/actions';

import * as S from './styles';

export default function Toolbar() {
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [exeUpload, setExeUpload] = useState(false);

  const [file, setFile] = useState({});

  const [telaAtual, setTelaAtual] = useState('telaPrincipal');
  const [message, setMessage] = useState('');

  const { client, id } = useSelector((state) => state.user.profile);

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const { params } = useSelector((state) => state.notafiscalrecebida);

  const mudarTela = (novaTela) => {
    setTelaAtual(novaTela);
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     handleOnFileUpload(file);
  //   }
  // };

  const execOnFileUpload = useCallback(
    async (file) => {
      if (!file) {
        toast.error('Nenhum arquivo selecionado!');
        return;
      }
      setFile(file);
      setExeUpload(true);
      mudarTela('telaUploadProgress');
    },
    [client, id]
  );

  useEffect(() => {
    if (exeUpload) handleOnFileUpload(file);
  }, [exeUpload, file]);

  const handleOnFileUpload = useCallback(
    async (file) => {
      if (!file) {
        toast.error('Nenhum arquivo selecionado!');
        return;
      }

      const getServerErrorMessage = (error) => {
        if (isArray(error) && error.length > 0) {
          return error.filter(Boolean).join(' ');
        }

        const responseData = error?.response?.data;
        const directData = error?.data;
        const payload = responseData || directData || error;
        const serverErrors =
          payload?.erros || payload?.errors || payload?.erro || payload?.error;

        if (isArray(serverErrors) && serverErrors.length > 0) {
          return serverErrors.join(' ');
        }

        if (typeof serverErrors === 'string' && serverErrors.trim()) {
          return serverErrors;
        }

        if (typeof payload?.message === 'string' && payload.message.trim()) {
          return payload.message;
        }

        if (typeof payload === 'string' && payload.trim()) {
          try {
            const parsedPayload = JSON.parse(payload);
            const parsedErrors =
              parsedPayload?.erros ||
              parsedPayload?.errors ||
              parsedPayload?.erro ||
              parsedPayload?.error;

            if (isArray(parsedErrors) && parsedErrors.length > 0) {
              return parsedErrors.join(' ');
            }

            if (typeof parsedErrors === 'string' && parsedErrors.trim()) {
              return parsedErrors;
            }

            if (
              typeof parsedPayload?.message === 'string' &&
              parsedPayload.message.trim()
            ) {
              return parsedPayload.message;
            }
          } catch (e) {
            return payload;
          }
        }

        return 'Erro ao enviar o arquivo.';
      };

      try {
        setLoading(true);
        mudarTela('telaUploadProgress');

        // Lendo o arquivo como Base64
        const reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onload = async () => {
          try {
            const base64String = reader.result.split(',')[1]; // Remove o prefixo "data:..."

            const formData = new FormData();
            formData.append('nomearquivo', file.name); // Adiciona o nome do arquivo
            formData.append('arquivoBase64', base64String); // Adiciona o Base64
            formData.append('idcliente', client); // Id do cliente
            formData.append('idusuario', id); // Id do usuário

            setUploadProgress(0); // Resetar o progresso
            setMessage(''); // Limpar a mensagem de erro/sucesso

            const response = await api.post('/nfbase/uploadnf', formData, {
              onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setUploadProgress(percentCompleted - 10); // Atualizar o progresso
              },
              headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (
              response.status === 200 ||
              response.status === 201 ||
              response.status === 202
            ) {
              toast.success(
                'Arquivo enviado. As alterações serão refletidas na sua base após o processamento (até 1 min). Você pode aguardar o auto refresh ou executar uma nova pesquisa.'
              );
              mudarTela('telaPrincipal');
            } else {
              toast.error(getServerErrorMessage(response));
              mudarTela('telaPrincipal');
            }
          } catch (error) {
            mudarTela('telaPrincipal');
            console.error('Erro no upload:', error);
            toast.error(getServerErrorMessage(error));
            setUploadProgress(0);
          }
        };
      } catch (error) {
        console.error('Erro no upload:', error);
        toast.error(getServerErrorMessage(error));
        setUploadProgress(0);
      } finally {
        inputRef.current.value = null; // Limpar o campo de input
        setLoading(false);
        // mudarTela("telaPrincipal");
        setExeUpload(false);
      }
    },
    [client, id]
  );

  const handleOnFileUploadOLD_ = useCallback(
    async (file) => {
      try {
        const headers = {
          'Content-Type': 'multipart/form-data',
        };

        setLoading(true);

        const formData = new FormData();

        formData.append('file', file, file.name);

        formData.append('idcliente', client);
        formData.append('idusuario', id);

        mudarTela('telaUploadProgress');

        const response = await api.post('/nfbase/uploadnf', formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
          headers,
        });

        toast.success('Arquivo enviado com sucesso!');

        mudarTela('telaPrincipal');
      } catch (error) {
        if (isArray(error)) error.map((err) => toast.error(t(err)));
        else toast.error(t(error));
        setUploadProgress(0);
        mudarTela('telaPrincipal');
      } finally {
        inputRef.current.value = null;
        setUploadProgress(0);
        mudarTela('telaPrincipal');
        setLoading(false);
        dispatch(recordFiltering(params));
      }
    },
    [params]
  );

  return (
    <>
      <S.FileUpload
        type="file"
        name="file"
        id="invoice"
        accept="text/xml"
        ref={inputRef}
        // onChange={({ target }) => handleOnFileUpload(target.files[0])}
        onChange={({ target }) => execOnFileUpload(target.files[0])}
      />

      {canURL().create && telaAtual === 'telaPrincipal' && (
        <S.Wrapper htmlFor="invoice">
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<AttachFile />}
            disabled={loading}
          >
            Upload
          </Button>
        </S.Wrapper>
      )}

      {telaAtual === 'telaUploadProgress' && (
        <>
          {uploadProgress > 0 && (
            <S.ProgressContainer>
              <p>Progresso do envio: {uploadProgress}%</p>
              <S.ProgressBar value={uploadProgress} max="100" />
            </S.ProgressContainer>
          )}
        </>
      )}
    </>
  );
}
